import { AwsAmplyfyConfig } from './env-urls';

const awsConfig = {};

awsConfig.Auth = AwsAmplyfyConfig;

export default awsConfig;
